import { FC } from 'react'
import s from './GigAssist.module.sass'
import { Template } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import type { Range } from '@widgets/Restaurant/RestCards/RestCard/type/type'
import TypeAndPrice from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice/TypeAndPrice'
import { Place } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/Place'
import { ScheduleAndPrice } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/ScheduleAndPrice'
// import { useCurrentSize } from '@shared/lib/helpers/classes'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'
import { Text } from '@shared/ui/Typography/Text'

const GigAssist: FC<
  TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ gigAssistVariant = 'modal', ...props }) => {
  // const [size] = useCurrentSize(props.sizes)

  const price = props.data.price || { level: null as number | null, tag: { url: '' } }
  const metro = props.data.address?.metro || null
  const address = props.data.address?.address || ''
  const discounts = props.data.discounts || { remarked: null, restoplace: null, tastyclub: null }
  const schedule = props.data.schedule || null

  return (
    <BlockBoundary>
      <Template
        {...props}
        className={`${props.className || ''} ${s.card}`}
        data-assist-carousel={true}
        data-gig-assist-variant={gigAssistVariant}>
        {!!discounts.remarked && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{discounts.remarked}₽
          </PromoBadgeLabel>
        )}

        {!!discounts.restoplace && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{discounts.restoplace}₽
          </PromoBadgeLabel>
        )}

        <TypeAndPrice
          restType={props.data.type || ''}
          priceRange={price.level as Range<1, 5> | undefined}
          priceLink={price.tag?.url || ''}
        />

        <Place address={address} metro={metro} />

        <ScheduleAndPrice schedule={schedule} />

        {props.additionalData?.conclusion && (
          <Text sizes={'S'} className={s.conclusion} title={props.additionalData.conclusion}>
            {props.additionalData?.conclusion}
          </Text>
        )}
      </Template>
    </BlockBoundary>
  )
}

export default GigAssist
